<template>
    <b-modal v-model="internalShow" @hide="$emit('update:show', false)" :title="$t('pickup.info')">
        <label class="form-text">{{ $t('pickup.address') }}</label>
        <div class="text-muted mb-3">
        {{ data.sender }}<br />
        {{ data.address.address }}<br/>
        {{ data.address.postal_code }} {{data.address.city }}<br />
        {{ data.address.country }}
            </div>
        <LGTInput :label="$t('pickup.fields.reference')" v-model="data.reference" :errors="errors" error-key="reference" :tooltip="$t('pickup.tooltips.referenceLength')">
            <template v-slot:afterInput>
                <div class="text-right small"><character-counter :limit="45" :value="data.reference"></character-counter></div>
            </template>
        </LGTInput>
        <div class="form-group">
            <label class="form-text">{{ $t('pickup.date') }}<required-icon></required-icon></label>
            <date-picker
                :lang="datepickerLang"
                class="w-100"
                v-model="data.date"
                format="DD/MM/YY"
                valueType="YYYY-MM-DD"
                type="date"
                placeholder=""
                :disabled-date="dateDisabled"
            ></date-picker>
            <span class="text-danger" v-if="errors['date']">{{ errors['date'][0] }}</span>
        </div>
        <div class="form-group">
            <label class="form-text">{{ $t('pickup.fields.time') }}<required-icon></required-icon></label>
            <date-picker
                :lang="datepickerLang"
                class="w-100"
                format="HH:mm"
                v-model="data.time"
                type="time"
                placeholder=""
                :minute-step="15"
                :show-second="false"
                value-type="format"
            ></date-picker>
            <span class="text-danger" v-if="errors['time']">{{ errors['time'][0] }}</span>
        </div>
        <div class="form-group">
            <label class="d-flex justify-content-between">
                <span>
                    {{ $t('pickup.comment') }}
                    <img src="/storage/info.png" height="15" v-b-tooltip="$t('pickup.tooltips.instructionLength')"/>
                </span>
                <character-counter :limit="50" v-model="data.comment"></character-counter>
            </label>
            <textarea type="text" v-model="data.comment" class="form-control" rows="4"></textarea>
            <small class="text-danger" v-if="errors['comment']">{{ errors['comment'][0] }}</small>

        </div>
        <hr class="mt-5">
        <h2>{{ $t('pickup.contact_info') }}</h2>
        <div class="form-group">
            <label class="form-text">{{ $t('pickup.contact_person_name') }}<required-icon></required-icon></label>
            <input type="text" class="form-control" v-model="data.contact.name"/>
            <span class="text-danger" v-if="errors['contact.name']">{{ errors['contact.name'][0] }}</span>
        </div>
        <div class="form-group">
            <label class="form-text">{{ $t('pickup.contact_person_phone') }}<required-icon></required-icon></label>
            <input type="text" class="form-control" v-model="data.contact.phone"/>
            <span class="text-danger" v-if="errors['contact.phone']">{{ errors['contact.phone'][0] }}</span>
        </div>
        <div class="form-group">
            <label class="form-text">{{ $t('pickup.contact_person_email') }}<required-icon></required-icon></label>
            <input type="text" class="form-control" v-model="data.contact.email"/>
            <span class="text-danger" v-if="errors['contact.email']">{{ errors['contact.email'][0] }}</span>
        </div>
        <template v-slot:modal-footer>
            <button class="btn btn-primary" @click="store">{{ $t('pickup.book') }}</button>
        </template>
    </b-modal>
</template>

<script>
import { BModal, VBTooltip } from 'bootstrap-vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/da'
import 'vue2-datepicker/locale/en'
import LGTInput from '@/Components/LGTInput'
import CharacterCounter from '@/Components/CharacterCounter'

export default {
    name: 'PickupModal',
    components: { LGTInput, BModal, DatePicker, CharacterCounter },
    directives: { 'b-tooltip': VBTooltip },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        bookings: {
            type: Array,
            default: [],
        },
    },
    data: function () {
        return {
            datepickerLang: document.documentElement.lang.substr(0, 2),
            internalShow: false,
            errors: {},
            data: {
                date: null,
                time: null,
                sender: null,
                contact: {
                    name: lgt.pickupDefaultContact.pickup_contact_name,
                    email: lgt.pickupDefaultContact.pickup_contact_email,
                    phone: lgt.pickupDefaultContact.pickup_contact_phone,
                },
                address: {},
                comment: '',
                goods: {
                    pll: null,
                    kll: null,
                    loadingMeters: null,
                    volume: null,
                    weight: null,
                },

            },
        }
    },
    watch: {
        show (val) {
            if(!val) return;
            this.internalShow = val
            this.data.sender = this.bookings[0].pickupAddress.name,
            this.data.address = {
                address: this.bookings[0].pickupAddress.address,
                postal_code: this.bookings[0].pickupAddress.postal_code,
                city: this.bookings[0].pickupAddress.city,
                country: this.bookings[0].pickupAddress.country,
            };

            this.data.goods = {
                pll: this.bookings.reduce((a,b) => {
                    return a+b.PLLCount;
                },0),
                kll: this.bookings.reduce((a,b) => {
                    return a+b.KLLCount;
                },0),
                loadingMeters: this.bookings.reduce((a,b) => {
                    return a+b.loadingMeterCount;
                },0),
                volume: this.bookings.reduce((a,b) => {
                    return a+b.CBMCount;
                },0),
                weight: this.bookings.reduce((a,b) => {
                    return a+b.weightCount;
                },0),
            }
        },
    },
    methods: {
        dateDisabled(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date < today
        },
        store() {
            axios.post('pickup', {...this.data, bookings: this.bookings}).then(response => {
                window.location = '/bookings?success'
            }).catch((err) => {
                this.errors = err.response.data.errors
            });
        }
    }
}
</script>
